module.exports = __webpack_public_path__ + "static/media/our_work_mr.c3b0a70f.svg";